module.exports = __webpack_public_path__ + "static/media/support.92ca19bf.svg";